import { getCampaignStatus } from '@esentai/core/features/campaigns/selectors';
import { connect } from 'react-redux';

import StatusIndicator from './component';

const mapStateToProps = (state, { itemId }) => ({
  status: getCampaignStatus(state, itemId),
});

export default connect(mapStateToProps)(StatusIndicator);
